
import {
  Category,
  CertImportResult,
  Content,
  NodeItem,
} from "@/script/apps/cms/entity/CmsEntity";
import { ElLoading, ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { MenuData } from "@/script/core/base/MenuData";
import bus from "@/script/core/util/Bus";
import { AppConfig } from "@/script/core/base/AppConfig";
import CertResult from "./CertResult.vue";

@Options({
  components: { CertResult },
})
export default class ContentList extends BaseList {
  private categoryList: Category[] | null = null;

  private treeData: NodeItem[] = [];

  private expandedKeys: number[] = [1];

  private selectedId: number | null = null;

  private categoryIds = "";

  private appName = "";

  defaultProps = {
    children: "children",
    label: "label",
  };

  private queryEntity: Content = {};

  private dataList: Content[] = [];

  private service = new ContentService();

  activated() {
    const categoryService = new CategoryService();
    categoryService.loadParentCategorys(0, (data: any) => {
      this.categoryList = data as Category[];

      const parentNodes: NodeItem[] = [];
      this.categoryList.forEach((item) => {
        if (item.parentId == null) {
          const parentNode: NodeItem = new NodeItem();
          parentNode.id = Number(item.id);
          parentNode.label = String(item.name);
          this.getChilds(this.categoryList!, parentNode);
          parentNodes.push(parentNode);
        }
      });
      this.treeData = parentNodes;
    });
  }

  public initData(): ServiceContext {
    this.appName = AppConfig.Config.AppName;
    this.queryParam.pager = {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      sorters: [
        { prop: "sortNo", sortField: "cc.sort_no", sortMode: "desc" },
        { prop: "id", sortField: "cc.id", sortMode: "desc" },
      ],
    };
    return ServiceFactory.build(
      "biz_cms_content",
      "/cms/content",
      "/cms/content",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      title: "",
    };
    return this.queryEntity;
  }

  addContent() {
    this.$router.push({
      path: this.serviceContext.detailUrl,
      query: {
        id: 0,
        type: "A",
        cache: "0",
        categoryId: this.selectedId,
        categoryIds: this.categoryIds,
      },
    });
    const menuData: MenuData = {
      name: String(this.serviceContext.listUrl),
      path: String(this.serviceContext.detailUrl),
      query: { type: "A", cache: "1" },
      isClose: true,
    };
    bus.emit("to-detail", menuData);
  }

  protected initOptions() {
    super.initOptions();
  }

  private getChilds(dataList: Category[], node: NodeItem) {
    const childNodes: NodeItem[] = [];
    dataList.forEach((item) => {
      if (item.parentId === node.id) {
        const childNode: NodeItem = new NodeItem();
        childNode.id = Number(item.id);
        childNode.label = String(item.name);
        childNodes.push(childNode);

        this.getChilds(dataList, childNode);
      }
    });
    node.children = childNodes;
  }

  private getChildIds(dataList: Category[], node: NodeItem, ids: number[]) {
    dataList.forEach((item) => {
      if (item.parentId === node.id) {
        const childNode: NodeItem = new NodeItem();
        ids.push(item.id!);
        this.getChildIds(dataList, childNode, ids);
      }
    });
  }

  public afterLoadList(data: any): void {
    const currDataList: Content[] = data.list as Content[];
    currDataList.forEach((item) => {});
    this.dataList = currDataList;
  }

  handleNodeClick(data: any) {
    this.selectedId = data.id;
    this.queryParam.extendMap = {};
    const ids: number[] = [data.id];
    this.getChildIds(this.categoryList!, data, ids);
    this.queryParam.extendMap.categoryIds = ids.join(",");
    this.categoryIds = this.queryParam.extendMap.categoryIds;
    this.loadList();
  }

  setTop(data: any) {
    this.service.setTop(data).then(
      (result) => {
        console.info(result);
        if (result.success) {
          ElMessage({ type: "success", message: result.message });
          this.loadList();
        } else {
          ElMessage({ type: "error", message: result.message });
        }
      },
      (error: Error) => {
        ElMessage.error("置顶失败！原因：" + error);
      }
    );
  }

  importExcel(param: any) {
    const loading = ElLoading.service({
      lock: true,
      text: "证书导入中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    const formData = new FormData();
    formData.append("path", "3ACret");
    formData.append("files", param.file, param.file.name);

    this.service.importExcel(
      "/api/cms/content/cert/import",
      formData,
      (result: any) => {
        loading.close();
        const certResult = result.data as CertImportResult;
        (this.$refs.certResult as CertResult).show(certResult);
      }
    );
  }
}
